export default {
  path: '/anomalias',
  component: () => import('@/components/pages/Anomalies/Anomalies.vue')
}
